/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-10",
    versionChannel: "nightly",
    buildDate: "2025-04-10T00:06:52.117Z",
    commitHash: "5aa7f0276a78e9c222ff927539dce86c8876c73d",
};
